import { render, staticRenderFns } from "./TransferAddModal.vue?vue&type=template&id=6b68bf10&scoped=true&"
import script from "./TransferAddModal.vue?vue&type=script&lang=ts&"
export * from "./TransferAddModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b68bf10",
  null
  
)

export default component.exports